import { kstDay } from '@/utils/fulfillmentTime';

/** Orders this PC packed or checked today; kept in the browser only, so a reload or a new tab still shows them. */
export const PACKING_CHECK_LOG_KEY = 'ff.packingCheck.today.v1';

/** How many orders the list keeps; older ones fall off the end. */
const KEEP = 200;

/** PACKED: the carrier label was scanned and the box closed; COMPLETE: every unit checked, no label yet; LEFT: units missing. */
export type CheckedResult = 'PACKED' | 'COMPLETE' | 'LEFT';

export interface CheckedOrder {
  orderId: number;
  /** When the order was last left or completed, as an ISO instant. */
  at: string;
  scanned: number;
  expected: number;
  result: CheckedResult;
}

interface StoredLog {
  day: string;
  orders: CheckedOrder[];
}

/** Today's list on the warehouse clock; anything stored on another day, or unreadable, reads as empty. */
export const readCheckedToday = (nowIso: string): CheckedOrder[] => {
  try {
    const raw = window.localStorage.getItem(PACKING_CHECK_LOG_KEY);
    if (!raw) {
      return [];
    }
    const stored = JSON.parse(raw) as StoredLog;
    return stored.day === kstDay(nowIso) && Array.isArray(stored.orders) ? stored.orders : [];
  } catch {
    return [];
  }
};

/** Puts the order at the top of today's list, replacing an earlier entry for it. */
export const recordChecked = (list: readonly CheckedOrder[], entry: CheckedOrder): CheckedOrder[] =>
  [entry, ...list.filter((row) => row.orderId !== entry.orderId)].slice(0, KEEP);

/** A browser that refuses storage (private window, full quota) only loses the list, never the check. */
export const writeCheckedToday = (nowIso: string, orders: readonly CheckedOrder[]): void => {
  try {
    const stored: StoredLog = { day: kstDay(nowIso), orders: [...orders] };
    window.localStorage.setItem(PACKING_CHECK_LOG_KEY, JSON.stringify(stored));
  } catch {
    // Nothing to do: the list is a convenience on this PC.
  }
};
